// src/locales/ta/productTags.js
export const productTags = {
  // Page titles and descriptions
  title: "தயாரிப்பு குறிச்சொற்கள்",
  description: "உங்கள் தயாரிப்புகளை திறம்பட ஒழுங்கமைக்க மற்றும் வகைப்படுத்த தயாரிப்பு குறிச்சொற்களை நிர்வகிக்கவும்",
  
  // Navigation
  addTag: "குறிச்சொல் சேர்க்கவும்",
  createNewTag: "புதிய குறிச்சொல் உருவாக்கவும்",
  editTag: "குறிச்சொல் திருத்தவும்",
  createFirstTag: "முதல் குறிச்சொல் உருவாக்கவும்",
  
  // Form Fields
  tagName: "குறிச்சொல் பெயர்",
  tagNamePlaceholder: "குறிச்சொல் பெயரை உள்ளிடவும் (எ.கா: புதிய வருகை, சிறந்த விற்பனை, விற்பனை)",
  
  // Table Headers
  name: "பெயர்",
  createdAt: "உருவாக்கப்பட்டது",
  updatedAt: "கடைசியாக புதுப்பிக்கப்பட்டது",
  
  // Search and Filter
  searchTags: "பெயரால் குறிச்சொற்களைத் தேடவும்...",
  filteredResults: "{{total}} இல் {{count}} குறிச்சொற்கள்",
  totalTags: "{{count}} குறிச்சொற்கள்",
  
  // Validation Messages
  nameRequired: "குறிச்சொல் பெயர் தேவை",
  nameMinLength: "குறிச்சொல் பெயர் குறைந்தபட்சம் 2 எழுத்துக்களாக இருக்க வேண்டும்",
  nameMaxLength: "குறிச்சொல் பெயர் 50 எழுத்துக்களை தாண்ட முடியாது",
  
  // Actions
  createTag: "குறிச்சொல் உருவாக்கவும்",
  updateTag: "குறிச்சொல் புதுப்பிக்கவும்",
  saveChanges: "மாற்றங்களை சேமிக்கவும்",
  
  // Success/Error Messages
  tagCreatedSuccess: "'{{tagName}}' குறிச்சொல் வெற்றிகரமாக உருவாக்கப்பட்டது!",
  tagUpdatedSuccess: "'{{tagName}}' குறிச்சொல் வெற்றிகரமாக புதுப்பிக்கப்பட்டது!",
  tagDeletedSuccess: "'{{tagName}}' குறிச்சொல் வெற்றிகரமாக நீக்கப்பட்டது.",
  failedToCreate: "குறிச்சொல் உருவாக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
  failedToUpdate: "குறிச்சொல் புதுப்பிக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
  failedToDelete: "குறிச்சொல் நீக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
  failedToLoadTag: "குறிச்சொல் விவரங்களை ஏற்ற முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
  failedToLoadTags: "குறிச்சொற்களை ஏற்ற முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
  
  // Loading states
  loadingTags: "குறிச்சொற்கள் ஏற்றப்படுகின்றன...",
  loadingTagsDesc: "உங்கள் தயாரிப்பு குறிச்சொற்களைப் பெறும் வரை காத்திருக்கவும்.",
  savingTag: "குறிச்சொல் சேமிக்கப்படுகிறது...",
  deletingTag: "குறிச்சொல் நீக்கப்படுகிறது...",
  
  // Empty states
  noTags: "இன்னும் குறிச்சொற்கள் இல்லை",
  noTagsDesc: "லேபிள்கள் மற்றும் வகைகளுடன் உங்கள் தயாரிப்புகளை ஒழுங்கமைக்க உங்கள் முதல் தயாரிப்பு குறிச்சொல்லை உருவாக்கவும்.",
  noSearchResults: "குறிச்சொற்கள் கிடைக்கவில்லை",
  noSearchResultsDesc: "உங்கள் தேடல் சொற்களை சரிசெய்ய முயற்சிக்கவும் அல்லது அனைத்து குறிச்சொற்களையும் பார்க்க வடிகட்டிகளை அழிக்கவும்.",
  
  // Confirmation dialogs
  confirmDelete: "'{{tagName}}' குறிச்சொல்லை நீக்குவது உறுதியா? இந்த செயலை மாற்ற முடியாது மற்றும் இந்த குறிச்சொல்லைப் பயன்படுத்தும் தயாரிப்புகளை பாதிக்கலாம்.",
  confirmDeleteTitle: "குறிச்சொல் நீக்கவும்",
  
  // Status and metadata
  createdDate: "{{date}} அன்று உருவாக்கப்பட்டது",
  updatedDate: "கடைசியாக {{date}} அன்று புதுப்பிக்கப்பட்டது",
  businessTag: "வணிக குறிச்சொல்",
  
  // Form validation hints
  nameHint: "உங்கள் தயாரிப்புகளை வகைப்படுத்த உதவும் விளக்கமான பெயர்களைப் பயன்படுத்தவும் (எ.கா: 'பருவகால', 'சிறப்பு', 'அனுமதி')",
  duplicateNameError: "இந்த பெயரில் ஏற்கனவே ஒரு குறிச்சொல் உள்ளது",
  
  // Sorting
  sortBy: "வரிசைப்படுத்து",
  sortByName: "பெயர்",
  sortByCreated: "உருவாக்கப்பட்ட தேதி",
  sortByUpdated: "புதுப்பிக்கப்பட்ட தேதி",
  ascending: "ஏறுவரிசை",
  descending: "இறங்குவரிசை"
};